export const firstError = (errors) => {
    return (errors && errors[0]) || undefined;
};
